/* Bootstrap tooltips */
$('[data-toggle="tooltip"]').tooltip();

